import Tabs from "components/tabs";
import GradeContent from "./component/grade-content";
import { GRADE_DESCARGA, GRADE_CARREGAMENTO } from "./constants";
import {
  getLoadCapacities,
  getUnloadCapacities,
  saveLoadCapacity,
  saveUnloadCapacity,
} from "./grade.service";

import GradeStyle from "./grade.styled";
import intl from "react-intl-universal";

const Grade = () => {
  const gradeContent = [
    {
      key: 1,
      label: intl.get("master-data.managementUnity.grid.dischargeDegree.header.title"),
      content: (
        <GradeContent
          type={GRADE_DESCARGA}
          filters="filtersGradeDescarga"
          searchGrade={getUnloadCapacities}
          saveGrade={saveUnloadCapacity}
          findIndexUpdateList={(listaGrade, grade) =>
            listaGrade.findIndex((g) => g.IdFamilia == grade.IdFamilia)
          }
          saveMessageSucess={intl.get("master-data.managementUnity.grid.dischargeDegree.header.messageSuccess")}
          title={intl.get("master-data.managementUnity.grid.dischargeDegree.header.title")}
          subTitle={intl.get("master-data.managementUnity.grid.dischargeDegree.header.subtitle")}
        />
      ),
    },
    {
      key: 2,
      label: intl.get("master-data.managementUnity.grid.loadingGrid.header.title"),
      content: (
        <GradeContent
          type={GRADE_CARREGAMENTO}
          filters="filtersGradeCarregamento"
          searchGrade={getLoadCapacities}
          saveGrade={saveLoadCapacity}
          findIndexUpdateList={(listaGrade, grade) =>
            listaGrade.findIndex((g) => g.IdOrigem == grade.IdOrigem)
          }
          saveMessageSucess={intl.get("master-data.managementUnity.grid.loadingGrid.header.messageSuccess")}
          title={intl.get("master-data.managementUnity.grid.loadingGrid.header.title")}
          subTitle={intl.get("master-data.managementUnity.grid.loadingGrid.header.subtitle")}
        />
      ),
    },
  ];

  return (
    <GradeStyle>
      <Tabs tabsContent={gradeContent} />
    </GradeStyle>
  );
};

export default Grade;
